/**
 * Two-line result type. Expected failures are values, not exceptions
 * ([CODE_STYLE.md](../docs/CODE_STYLE.md)) — a device that is gone or a fix that never
 * arrives is an ordinary field outcome, so the caller decides what the operator sees.
 */
export type Result<T, E> = { ok: true; value: T } | { ok: false; error: E };

export const ok = <T>(value: T): Result<T, never> => ({ ok: true, value });
export const err = <E>(error: E): Result<never, E> => ({ ok: false, error });
